module.exports = __webpack_public_path__ + "static/media/COS_NOREVA.ec05b034.jpg";